import { useMutation } from '@tanstack/react-query';
import { syncWorkflowPostProcessingConfig } from 'services/api/WorkflowServiceAPI';

export const useSyncWorkflowPostProcessingConfig = () => {
    const { mutate: syncPostProcessingConfig, isPending } = useMutation({
        mutationFn: (id: string) => syncWorkflowPostProcessingConfig(id),
        retry: 0,
    });

    return {
        syncWorkflowPostProcessingConfig: syncPostProcessingConfig,
        isPending,
    };
};
